export interface ServerContext {
  CurrentAccount: {
    Id: number;
    AdvertiserCustomerID: number;
  };
  CurrentUser: {
    Locale: string;
  };
  PageTrackingId: string;
  ServicesEndpoints: {
    CmAPI: string;
  };
  Token: string;
}
export interface SharedEntity {
  Id: number;
  Name: string;
  Description: string;
  Type: string;
  Scope: string;
}
export interface BatchErrors {
  Index: number;
  Message: string;
}
export interface SharedEntityAssociation {
  EntityId: number;
  EntityType: 'Campaign' | 'Account';
  SharedEntityId: number; // AccountPlacementExclusionListId
  SharedEntityType: 'AccountPlacementExclusionList';
  SharedEntityCustomerId?: number; // Ignore for account level
}
export interface SetSharedEntityAssociationsRequest {
  Associations: SharedEntityAssociation[];
  SharedEntityScope: string;
}
export interface GetSharedEntitiesRequest {
  SharedEntityScope: string;
  SharedEntityType: string;
  SharedEntityId: number;
}
export interface GetSharedEntitiesResponse {
  SharedEntities: SharedEntity[];
  PartialErrors?: BatchErrors[];
}
export interface SetSharedEntityAssociationsResponse {
  PartialErrors?: BatchErrors[];
}
export interface DeleteSharedEntityAssociationsRequest {
  Associations: SharedEntityAssociation[];
  SharedEntityScope: string;
}
export interface DeleteSharedEntityAssociationsResponse {
  PartialErrors?: BatchErrors[];
}
export interface GetSharedEntityAssociationsByEntityIdsRequest {
  EntityIds: number[];
  EntityType: string;
  SharedEntityScope: string;
  SharedEntityType: string;
}
export interface GetSharedEntityAssociationsByEntityIdsResponse {
  Associations: SharedEntityAssociation[];
  PartialErrors?: BatchErrors[];
}
export enum RequestMethod {
  Post = 'POST',
  Delete = 'DELETE'
}
